var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quiz_bt_area"},[_c('a',{staticClass:"quiz_bt detail_bt",attrs:{"href":_vm.hint_url,"target":"_blank"},on:{"click":_vm.clickHandler}},[_c('span',[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }